import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.342 6.142a8.868 8.868 0 0 0 12.516 12.516L5.342 6.142Zm.8-.8 12.516 12.516A8.868 8.868 0 0 0 6.142 5.342ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z"
      clip-rule="evenodd"
    />
  </svg>
`;
